<template>
  <div>
    <!-- Filtros -->
    <v-card v-if="filtros && !modal" class="mb-4">
      <v-toolbar dense color="grey lighten-2">
        <v-toolbar-title class="title">Filtros</v-toolbar-title>
        <v-divider
          class="mx-2"
          inset
          vertical
        ></v-divider>
        <v-spacer></v-spacer>
        <v-tooltip bottom>
          <v-btn flat icon @click="filtros = false" slot="activator">
            <v-icon>close</v-icon>
          </v-btn>
          <span>Cancelar</span>
        </v-tooltip>
        
        <v-tooltip bottom>
          <v-btn fab dark small color="primary" icon @click="aplicaFiltros" slot="activator">
            <v-icon>done</v-icon>
          </v-btn>
          <span>Aplicar</span>
        </v-tooltip>
      </v-toolbar>
      <v-container fluid grid-list-xl>
        <!-- <v-layout row wrap>
          <v-flex xs12 md3>
            <v-select
              v-model="filtroSelected"
              :items="filtroAtividades"
              item-text="text"
              item-value="value"
              prepend-icon="description"
              label="Filtrar Atividades"
              no-data-text="Nenhum registro encontrado"
            ></v-select>
          </v-flex>
          <v-flex xs12 md3 v-if="filtroSelected == 'periodo'">
            <v-menu v-model="periodoDatepickerInicial" :close-on-content-click="false" full-width>
              <v-text-field readonly slot="activator"
                :value="moment(periodo.dataInicial).format('DD/MM/YYYY')" label="Data Inicial" prepend-icon="event">
              </v-text-field>
              <v-date-picker @change="periodoDatepickerInicial = false" locale="pt" v-model="periodo.dataInicial"></v-date-picker>
            </v-menu>
            <v-menu v-model="periodoDatepickerFinal" :close-on-content-click="false" full-width>
              <v-text-field readonly slot="activator"
                :value="moment(periodo.dataFinal).format('DD/MM/YYYY')" label="Data Final" prepend-icon="event">
              </v-text-field>
              <v-date-picker @change="periodoDatepickerFinal = false" locale="pt" v-model="periodo.dataFinal"></v-date-picker>
            </v-menu>
          </v-flex>
        </v-layout> -->
        <v-layout row wrap>
          <v-flex xs12 md3>
            <v-select
              v-model="statusSelected"
              item-text="Descricao"
              return-object
              :items="JSON.parse(layoutSelected.Configuracoes).statusSelected"
              label="Filtrar Status"
              prepend-icon="description"
              no-data-text="Nenhum registro encontrado"
              multiple
            ></v-select>
          </v-flex>
        </v-layout>
      </v-container>
    </v-card>
    <div :class="filtros ? '' : 'pos-abs-fixed'">
      <v-toolbar v-if="!modal" color="grey lighten-2" dense>
        <v-flex md3>
          <v-select
            v-model="layoutSelected"
            :items="layoutsSql"
            item-text="Titulo"
            return-object
            no-data-text="Nenhum registro encontrado"
            @change="changeLayoutSql"
          ></v-select>
        </v-flex>
        <v-divider
          class="mx-2"
          inset
          vertical
        ></v-divider>
        <div v-if="$vuetify.breakpoint.mdAndUp">
          <v-chip v-for="status in statusSelected" :key="status" dark :color="statusCor(status)">{{ status[0] }}</v-chip>
        </div>
        <v-divider
          class="mx-2"
          inset
          vertical
        ></v-divider>
        <v-spacer></v-spacer>
        <v-flex xs4 px-3 v-if="$vuetify.breakpoint.mdAndUp">
          <v-text-field 
            @input="search"
            v-model="timeoutSearchTerm"
            prepend-inner-icon="search"
            clearable
          ></v-text-field>
        </v-flex>
        <v-tooltip bottom>
          <v-btn
            color="primary" 
            fab 
            dark 
            small
            @click="$emit('abreModalGridSyclus')"
            slot="activator"
          >
            <v-icon>add</v-icon>
          </v-btn>
          <span>Adicionar</span>
        </v-tooltip>
        <v-tooltip bottom>
          <v-btn flat icon small slot="activator" @click="aplicaFiltros" :loading="loading">
            <v-icon>refresh</v-icon>
          </v-btn>
          <span>Atualizar</span>
        </v-tooltip>
        <v-tooltip bottom>
        <span>Opções</span>
          <v-menu bottom left slot="activator">
            <v-btn flat icon small slot="activator">
              <v-icon>more_vert</v-icon>
            </v-btn>
            <v-list>
              <v-list-tile @click="$emit('editItemSelected', selected)" class="cursor-pointer">
                <v-list-tile-title>
                  <v-icon small class="pr-1">edit</v-icon>Alterar
                  </v-list-tile-title>
              </v-list-tile>
              <v-list-tile @click="$emit('deleteItemSelected', selected)" class="cursor-pointer">
                <v-list-tile-title>
                  <v-icon small class="pr-1">delete</v-icon>Excluir
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile v-if="setaTag" @click="$emit('abreModalSetaTag', selected)" class="cursor-pointer">
                <v-list-tile-title>
                  <v-icon small class="pr-1">label_important</v-icon>Setar Tag
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile v-if="inativaCliente" @click="$emit('abreModalInativaCliente', selected)" class="cursor-pointer">
                <v-list-tile-title>
                  <v-icon small class="pr-1">person_add_disabled</v-icon>Inativar
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile v-if="inativaCliente" @click="$emit('reativaCliente', selected)" class="cursor-pointer">
                <v-list-tile-title>
                  <v-icon small class="pr-1">person_add</v-icon>Reativar
                </v-list-tile-title>
              </v-list-tile>
              <v-list-tile v-if="setaSenha && isAdmin" @click="$emit('abreModalSetaSenha', selected)" class="cursor-pointer">
                <v-list-tile-title>
                  <v-icon small class="pr-1">label_important</v-icon>Setar Senha
                </v-list-tile-title>
              </v-list-tile>
            </v-list>
          </v-menu>
        </v-tooltip>
        <v-tooltip bottom>
          <v-btn flat icon small slot="activator" @click="filtros = !filtros">
            <v-icon>filter_list</v-icon>
          </v-btn>
          <span>Filtros</span>
        </v-tooltip>
      </v-toolbar>
      <v-toolbar v-else color="grey lighten-2" dense>
        <v-layout row wrap>
          <v-flex xs12 md6 align-self-center>
            <h3>Selecione os clientes para vincular e criar atividades</h3>
          </v-flex>
          <v-flex xs12 md4>
            <v-text-field 
              @input="search"
              v-model="timeoutSearchTerm"
              prepend-inner-icon="search"
              clearable
            ></v-text-field>
          </v-flex>
          <v-flex xs12 md2 class="text-xs-right zindex" align-self-center>
            <v-tooltip bottom>
              <v-btn
                flat
                icon
                small
                slot="activator"
                @click="aplicaFiltros"
                :loading="loading"
              >
                <v-icon>refresh</v-icon>
              </v-btn>
              <span>Atualizar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <v-btn
                slot="activator"
                fab 
                flat
                small
                @click="$emit('fecharModal')"
              >
                <v-icon>close</v-icon>
              </v-btn>
              <span>Cancelar</span>
            </v-tooltip>
            <v-tooltip bottom>
              <v-btn
                slot="activator"
                color="primary" 
                fab 
                dark 
                small
                @click="vinculaClientes"
              >
                <v-icon>done</v-icon>
              </v-btn>
              <span>Vincular</span>
            </v-tooltip>
          </v-flex>
        </v-layout>
      </v-toolbar>
    </div>
    <v-data-table
      v-model="selected"
      :headers="headers"
      :items="computedItems"
      :item-key="itemKey"
      class="elevation-1"
      rows-per-page-text="Registros"
      select-all
      :pagination.sync="defaultPagConfig"
      :loading="loading"
      :search="searchTerm"
      no-data-text="Nenhum registro encontrado"
    >
      <v-progress-linear v-slot:progress color="blue" indeterminate></v-progress-linear>
      <template v-slot:items="props">
        <tr
          :active="props.selected"
          class="cursor-pointer"
          @dblclick="$emit('editItemSelected', props.item)"
          @click="props.selected = !props.selected"
        >
          <td>
            <v-checkbox :input-value="props.selected" primary color="primary" hide-details></v-checkbox>
          </td>
          <td v-for="(header, index) in headers" :key="index">
            <v-avatar v-if="header.value === 'Status'" size="32" :color="statusCor(props.item.Status)">
              <span class="white--text">{{ props.item.Status[0] }}</span>
            </v-avatar>
            <v-avatar v-if="header.value === 'Cor'" size="32" :color="props.item.Cor" />
            <span v-if="filtraHeaders(header)">{{ props.item[header.value] }}</span>
          </td>
        </tr>
      </template>
      <template v-slot:no-results>
        <v-alert
          :value="true"
          color="error"
          icon="warning"
        >Pesquisa por "{{ searchTerm }}" não encontrou resultados.</v-alert>
      </template>
      <template v-slot:pageText="props">
        {{ props.pageStart }} - {{ props.pageStop }} de {{ props.itemsLength }}
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { clearTimeout, setTimeout } from 'timers';
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'GridSyclus',
  props: {
    idRecursoSistema: {
      type: Number,
      required: true
    },
    title: {
      type: String,
      default: 'My CRUD'
    },
    headers: {
      type: Array,
      required: true
    },
    customHeaders: {
      type: Array,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    itemKey: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    setaTag: {
      type: Boolean,
      default: false
    },
    setaSenha: {
      type: Boolean,
      default: false
    },
    inativaCliente: {
      type: Boolean,
      default: false
    },
    modal: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    selected: [],
    filtros: false,
    timeout: null,
    layoutSelected: null,
    tiposRecursoSelected: [],
    statusSelected: [],
    searchTerm: '',
    timeoutSearchTerm: '',
    defaultPagConfig: {
      descending: false,
      page: 1,
      rowsPerPage: 10, // -1 for All"
      sortBy: "Descricao"
    },
  }),

  computed: {
    ...mapGetters(['user', 'layoutsSql', 'isAdmin']),
    computedItems() {
      return this.items.filter(item => this.statusSelected.map(status => status[0]).includes(item.Status.trim()));
    },
  },

  methods: {
    ...mapActions(['fetchLayoutsSqlUsuario']),

    search() {
      clearTimeout(this.timeout);

      this.timeout = setTimeout(() => {
        this.searchTerm = this.timeoutSearchTerm;
      }, 500);
    },

    changeLayoutSql(obj) {
      this.$emit('changeLayoutSql', obj.IdLayoutSql);
      this.preparaFiltrosLayout();
      this.aplicaFiltros();
    },

    preparaFiltrosLayout() {
      this.tiposRecursoSelected = JSON.parse(this.layoutSelected.Configuracoes).tiposRecursoSelected;
      if (localStorage.getItem(`statusGridSyclus${this.title}`)) {
        // Status selecionados no layout
        const statusConfig = JSON.parse(this.layoutSelected.Configuracoes).statusSelected;
        // Filtra apenas os status que estão contidos nos status do layout
        this.statusSelected = JSON.parse(localStorage.getItem(`statusGridSyclus${this.title}`))
          .filter(status => statusConfig.includes(status));
      } else {
        this.statusSelected = JSON.parse(this.layoutSelected.Configuracoes).statusSelected;
      }
    },
    buscaUltimoLayoutSql() {
      this.layoutSelected = this.layoutsSql[this.layoutsSql.length - 1];
    },
    buscaIdUltimoLayoutsql(id) {
      return this.layoutsSql.filter(layout => layout.IdLayoutSql == id)[0];
    },
    async inicializaLayoutSql() {
      const layoutSql = this.buscaIdUltimoLayoutsql(this.layoutSelected.IdLayoutSql);
      this.changeLayoutSql(layoutSql);
    },

    aplicaFiltros() {
      this.salvaConfigPesquisa();
      this.preparaFiltrosLayout();
      this.$emit('aplicaFiltros');
      this.filtros = false;
    },

    salvaConfigPesquisa() {
      localStorage.setItem(`GridSyclusPagConfig${this.title}`, JSON.stringify(this.defaultPagConfig));
      this.searchTerm ? localStorage.setItem(`GridSyclusSearchTerm${this.title}`, this.searchTerm) : localStorage.setItem(`GridSyclusSearchTerm${this.title}`, "");
      this.layoutSelected ? localStorage.setItem(`layoutSelectedGridSyclus${this.title}`, this.layoutSelected.IdLayoutSql) : localStorage.setItem(`layoutSelectedGridSyclus${this.title}`, null);
      localStorage.setItem(`statusGridSyclus${this.title}`, JSON.stringify(this.statusSelected));
    },

    recuperaConfigPesquisa() {
      // Verifica se existe no localStorage o item pagConfig salvo anteriormente
      if (localStorage.getItem(`GridSyclusPagConfig${this.title}`)) {
        this.defaultPagConfig = JSON.parse(localStorage.getItem(`GridSyclusPagConfig${this.title}`));
      }
      // Verifica se existe o termo pesquisado salvo anteriormente
      if (localStorage.getItem(`GridSyclusSearchTerm${this.title}`)) {
        this.searchTerm = localStorage.getItem(`GridSyclusSearchTerm${this.title}`);
        this.timeoutSearchTerm = localStorage.getItem(`GridSyclusSearchTerm${this.title}`);
      } else {
        this.searchTerm = '';
        this.timeoutSearchTerm = '';
      }
      if (localStorage.getItem(`layoutSelectedGridSyclus${this.title}`)) {
        const id = localStorage.getItem(`layoutSelectedGridSyclus${this.title}`);
        this.layoutSelected = this.buscaIdUltimoLayoutsql(id);
        this.preparaFiltrosLayout();
      } else {
        this.buscaUltimoLayoutSql();
        this.preparaFiltrosLayout();
      }
    },

    filtraHeaders(header) {
      return !this.customHeaders.includes(header.value);
    },

    statusCor(status) {
      if (status.startsWith('A')) return "#263238";
      if (status.startsWith('I')) return "info";
      if (status.startsWith('P')) return "#263238";
      if (status.startsWith('F')) return "#1976d2";
      if (status.startsWith('C')) return "#bdbdbd";
    },

    handleSearch(payload) {
      this.searchTerm = payload;
    },

    vinculaClientes() {
      this.$emit('vinculaClientes', this.selected);
      this.selected = [];
    }
  },
  async created() {
    await this.fetchLayoutsSqlUsuario({ usuario: this.user, idRecursoSistema: this.idRecursoSistema });
    this.recuperaConfigPesquisa();
    this.inicializaLayoutSql();
  }
}
</script>
<style scoped>
.pos-abs-fixed {
  z-index: 5;
  position: relative;
  padding-bottom: 50px;
}
.pos-abs-fixed > :first-child {
  position: fixed;
}
.cursor-pointer {
  cursor: pointer;
}
.zindex {
  z-index: 999;
}
</style>